import styled from "@emotion/styled";
import { Box, Grid, Typography } from "@mui/material";
import React from "react";

const ProvinceItem = styled(Box)(({ theme }) => ({
  textAlign: "center",
  borderLeft: "1px solid gray",
  height: "30px",
  display: "flex",
  flexDirection: "column",
}));
const MainItem = styled(Box)(({ theme }) => ({
  textAlign: "center",
  //   border: "1px solid gray",
  height: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  direction: "ltr",
}));
export default function CarTagView() {
  return (
    <Box
      sx={{
        width: "100px",
        borderRadius: "6px",
        border: "1px solid gray",
        backgroundColor: "#FFD54F",
      }}
    >
      <Grid container>
        <Grid item xs={3}>
          <ProvinceItem>
            <Typography
              sx={{
                color: "#000",

                fontSize: "8px",
              }}
            >
              ایران
            </Typography>
            <Typography
              sx={{
                color: "#000",
                fontWeight: "600",
                fontFamily: "YeBakhNu",
              }}
            >
              11
            </Typography>
          </ProvinceItem>
        </Grid>
        <Grid item xs={9}>
          <MainItem>
            <Typography
              sx={{
                color: "#000",
                fontWeight: "600",
                fontFamily: "YeBakhNu",
              }}
            >
              55
            </Typography>
            <Typography
              sx={{
                color: "#000",

                fontWeight: "300",
              }}
            >
              ع
            </Typography>
            <Typography
              sx={{
                color: "#000",
                fontWeight: "600",
                fontFamily: "YeBakhNu",
              }}
            >
              364
            </Typography>
          </MainItem>
        </Grid>
      </Grid>
    </Box>
  );
}
